import { defineMessages } from 'react-intl';

export default defineMessages({
    mainDriverInformation: {
        id: 'quoteandbind.views.contact-details.ba.Main Driver Information',
        defaultMessage: 'Main Driver Information',
    },
    baDateOfBirth: {
        id: 'quoteandbind.views.contact-details.ba.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    baFirstNameTooltip: {
        id: 'platform.inputs.contact-details.First Name.tooltip.ba.content',
        defaultMessage: 'Here you can add helpful text related to the field. You can use links too, for example:'
    },
    baLastNameTooltip: {
        id: 'platform.inputs.contact-details.Last Name.tooltip.ba.content',
        defaultMessage: 'Here you can add helpful text related to the field. You can use links too, for example:'
    },
    baTooltipLink: {
        id: 'platform.inputs.contact-details.tooltip.ba.Link',
        defaultMessage: 'Link'
    },
    baPleaseSelect: {
        id: 'quoteandbind.ba.views.common.Please Select',
        defaultMessage: 'Please Select',
    },
});
